// extracted by mini-css-extract-plugin
export default {"shadowBlockCorner":"NavBar_shadowBlockCorner__A9Lq6"};